var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoreExpand',{attrs:{"title":_vm.contactsHeading}},[_c('div',{staticClass:"text-4 md:text-3"},[_c('RichTextRenderer',{attrs:{"document":_vm.contacts,"node-renderers":_vm.nodeRenderer}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }